/**
 * @fileoverview POST handler for the "/companies/:company_id/custom_roles/create_custom_role" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdCustomRolesCreateCustomRoleCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdCustomRolesCreateCustomRoleProps,
  CompaniesCompanyIdCustomRolesCreateCustomRoleResult,
} from "./types";

export const postCompaniesCompanyIdCustomRolesCreateCustomRole = reactQueryMutationAdapter(
  companiesCompanyIdCustomRolesCreateCustomRoleCacheKeys,
  (
    props: PostCompaniesCompanyIdCustomRolesCreateCustomRoleProps
  ): Promise<CompaniesCompanyIdCustomRolesCreateCustomRoleResult> => {
    return fetch(`/companies/${props.companyId}/custom_roles/create_custom_role`, "POST", props.body);
  }
);
